module.exports = __webpack_public_path__ + "be3cf2f8b21dae33bbd57e9f6f05451b.svg";